import { makeStyles, createStyles } from "@material-ui/core";

export const useStyles = makeStyles(() =>
  createStyles({
    cardMain: {
      marginBottom: "0px",
      paddingTop: "2px",
      width: "calc(100%)",
    },
    cardSec: {
      paddingBottom: 0,
    },
  })
);
